// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// UI组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 三方组件
import vdiStPicker from 'v-distpicker'

// 系统自定义配置
import config from './js/config.js'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(ElementUI)
Vue.component('v-distpicker', vdiStPicker)

Vue.config.productionTip = false
Vue.prototype.JJW_URL = process.env.JJW_URL
Vue.prototype.CONFIG = config
Vue.prototype.NODE_ENV = process.env.NODE_ENV
Vue.prototype.PU_API = process.env.PU_API
Vue.prototype.HOME_JCX_URL = process.env.HOME_JCX_URL

Vue.prototype.SU_API = process.env.SU_API
Vue.prototype.ALI_OSS_API = process.env.ALI_OSS_API
Vue.prototype.HOME_PAGE_URL = process.env.HOME_PAGE_URL
Vue.prototype.SSO_PAGE_URL = process.env.SSO_PAGE_URL
Vue.prototype.SP_PAGE_URL = process.env.SP_PAGE_URL
Vue.prototype.PU_PAGE_URL = process.env.PU_PAGE_URL
Vue.prototype.MALL_PAGE_URL = process.env.MALL_PAGE_URL


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js